import { useEffect, useRef, useState } from "react"
import * as Icons from "@nova/component-icons"
import { ButtonPrimary } from "@nova/component-btn"
import { FirePerimeterManualKeyboardShortcuts } from "./FirePerimeterManualKeyboardShortcuts"
import { setActiveFeatureId, setActiveLayerId } from "panels/content/side-panel/slice.new"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import store from "integrations/redux/store"
import { setActiveSidePanelModal } from "panels/content/side-panel/slice"
import { geometryDataStore } from "plugins/shared/layers/GeometryDataStore"
import {
    clearEditingData,
    createNewMockedPerimeter,
    createNewMockedPolygon,
    selectUpdateMethod,
    updatePerimeterCanConfirm,
    selectEditingFirePerimeterId,
} from "plugins/DrawPerimeter/FirePerimeterSlice"
import { useEffectUnsafe } from "@nova/use-effect-unsafe"
import { useNonReactiveCallback } from "@nova/use-non-reactive-callback"
import { FirePerimeterMethod, ToolName } from "@nova/constants"
import { setActiveTool, selectActiveToolName } from "plugins/Toolbox/tool-registry"

export const FirePerimeterPluginActionMethodManual = () => {
    const dispatch = useAppDispatch()
    const activeTool = useAppSelector(selectActiveToolName())
    const activeToolRef = useRef<ToolName>(undefined)
    const perimeterId = useAppSelector(selectEditingFirePerimeterId())
    const newPerimeter = !perimeterId
    const updateMethod = useAppSelector(selectUpdateMethod())

    const [shortcutsIsOpen, setShortcutsIsOpen] = useState(false)

    useEffectUnsafe(() => {
        if (updateMethod !== FirePerimeterMethod.Manual) return
        if (newPerimeter) dispatch(createNewMockedPerimeter())
        else {
            geometryDataStore.free(true)
            dispatch(createNewMockedPolygon())
        }

        dispatch(setActiveTool(ToolName.FirePerimeter))
    }, [updateMethod])

    // Blur this hook's parent component when the active tool changes from FP to none.
    useEffectUnsafe(() => {
        if (!activeTool && activeToolRef.current === ToolName.FirePerimeter) {
            onBlur?.()
        }
        activeToolRef.current = activeTool
    }, [activeTool])

    const points = geometryDataStore.useGeometryData("points")
    const canConfirm = points.length >= 3

    useEffect(() => {
        dispatch(updatePerimeterCanConfirm(canConfirm))
    }, [canConfirm, dispatch])

    const onBlur = (save = true) => {
        geometryDataStore.free(save)
        dispatch(clearEditingData())
        dispatch(setActiveFeatureId({ feature: undefined }))
        dispatch(setActiveLayerId({ id: undefined }))
        if (save) store.dispatch(setActiveSidePanelModal(undefined))
    }
    const onBlurRef = useNonReactiveCallback(() => onBlur(false), [onBlur])

    useEffectUnsafe(() => {
        const onClosed = () => onBlurRef.current()
        geometryDataStore.on("closed", onClosed)
        return () => {
            onClosed()
            geometryDataStore.off("closed", onClosed)
        }
    }, [])

    return (
        <div>
            <div className="flex flex-col gap-4 pt-4">
                <ButtonPrimary
                    title="Confirm"
                    RightIcon={Icons.Checkmark}
                    disabled={!canConfirm}
                    onClick={() => onBlur()}
                />

                {/* Keyboard Shortcuts */}
                <div className="-mx-4">
                    <FirePerimeterManualKeyboardShortcuts
                        isOpen={shortcutsIsOpen}
                        setIsOpen={(isOpen) => setShortcutsIsOpen(isOpen)}
                    />
                </div>
            </div>
        </div>
    )
}
